import type { TextElement } from "@/react/types/Element";
import type { Form } from "@/react/types/Form";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Modal } from "@circle-react-uikit/ModalV2";

const isTitleTextElement = (element: any): element is TextElement =>
  element.type === "text" &&
  element.attributes.text_type === "title" &&
  element.attributes.value;
interface ModalHeaderProps {
  form: Form;
  handleClose: () => void;
  shouldHideTitle: boolean;
}
export const ModalHeader = ({
  form,
  handleClose,
  shouldHideTitle,
}: ModalHeaderProps) => {
  // this should always return either null or a TextElementType, HELP
  const titleElement = form.elements.find(isTitleTextElement);
  const showTitle = !shouldHideTitle && titleElement;
  return (
    <Modal.Header
      className={classNames("border-none", { "!justify-end": !showTitle })}
    >
      {showTitle ? (
        <>
          <Modal.Title>{titleElement.attributes.value}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton
              id="form-modal-close-button"
              onClick={handleClose}
            />
          </Modal.HeaderActions>
        </>
      ) : (
        <Modal.CloseButton id="form-modal-close-button" onClick={handleClose} />
      )}
    </Modal.Header>
  );
};
